<template>
  <el-table-column :width="50" align="center">
    <template slot-scope="scope">
      <div class="actions">
        <slot :row="scope.row"></slot>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: 'RestListColumnSingleAction'
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnSingleAction.vue